import * as React from "react";
import { Header } from "@origin-digital/tal-header";
import { Navigation } from "../../components/Navigation";
import { NoNavigationHeader } from "../../components/Navigation/NoNavigationHeader";

interface BaseAppContentProps {
  actionBar?: Window["oetal"]["pageData"]["actionBar"];
  showHeader: Window["oetal"]["pageData"]["showHeader"];
  crisisBanner: Window["oetal"]["pageData"]["crisisBanner"];
  title: string;
  isNative?: boolean;
}

export const CMSAppContent: React.FC<BaseAppContentProps> = ({
  showHeader,
  actionBar = {},
  title,
  crisisBanner = "none",
  isNative,
}) => {
  return (
    <>
      {showHeader === true && <Navigation />}
      {showHeader === "scoped" && <NoNavigationHeader />}
      <Header
        title={actionBar.title || title}
        desktopVariant={actionBar.desktopVariant}
        headingComponent={actionBar.component}
        isNative={isNative}
        hideActionBar={actionBar.hidden}
        navButton={actionBar.navButton}
        crisisBanner={crisisBanner}
        showAllProperties={actionBar?.propertySelector?.showAllProperties}
        secondaryColor={actionBar.secondaryColor}
      />
    </>
  );
};
